<template>
  <v-form @submit.prevent>
    <v-layout row wrap>
      <v-flex xs12>
        <div class="pb-2 text-xs-left" :class="[$style.headingText]">
          {{ lang.social_media_image_title }}
        </div>
        <div class="pb-2">{{ lang.social_media_image_description }}</div>
        <div class="pb-2" style="position: relative;">
          <v-img
            v-if="draftWallThumbnailImageUrl"
            :src="draftWallThumbnailImageUrl"
            contain
          ></v-img>
          <v-responsive v-else :aspect-ratio="2">
            <v-layout align-center justify-center fill-height>
              <v-progress-circular
                indeterminate
                color="grey lighten-1"
              ></v-progress-circular>
            </v-layout>
          </v-responsive>
          <iframe
            ref="reader"
            :src="readerLaunchUrl"
            style="position:absolute; left: 0; top: 0; z-index: -100; width: 10px; height: 10px;"
          ></iframe>
        </div>
      </v-flex>

      <v-flex xs12>
        <div class="pb-2 text-xs-left" :class="[$style.headingText]">
          {{ lang.title + lang.required }}
        </div>
        <v-text-field
          :counter="titleMaxLength"
          :label="lang.title + lang.required"
          v-model="title"
          v-validate="'required|max:' + titleMaxLength"
          data-vv-name="contentsTitle"
          :error-messages="errors.collect('contentsTitle')"
          required
          outline
          single-line
        ></v-text-field>
      </v-flex>

      <v-flex xs12>
        <div class="pb-2 text-xs-left" :class="[$style.headingText]">
          {{ lang.description + lang.required }}
        </div>
        <div class="pb-2 text-xs-left">{{ lang.description_hint }}</div>
        <v-textarea
          :label="lang.description + lang.required"
          v-model="description"
          no-resize
          :counter="descriptionMaxLength"
          v-validate="'required|max:' + descriptionMaxLength"
          data-vv-name="contentsDescription"
          :error-messages="errors.collect('contentsDescription')"
          required
          outline
          single-line
        ></v-textarea>
      </v-flex>

      <v-flex xs12>
        <p :class="[$style.headingText]">{{ lang.publication_type }}</p>
        <v-radio-group v-model="publicationType" column>
          <v-radio
            :label="lang.publication_type_private"
            value="private"
            v-on:change="changeSecretWord = false"
          ></v-radio>
          <v-radio
            :label="lang.publication_type_public"
            value="public"
            v-on:change="changeSecretWord = false"
          ></v-radio>
          <v-radio
            :label="lang.publication_type_secret_word"
            value="secret_word"
            v-on:change="
              initialPublicationType !== 'secret_word'
                ? (changeSecretWord = true)
                : ''
            "
          ></v-radio>
        </v-radio-group>

        <v-fade-transition leave-absolute>
          <v-layout row wrap v-if="publicationType === 'secret_word'">
            <v-flex v-if="initialPublicationType !== 'secret_word'" xs12>
              <v-card max-width="500">
                <v-card-title class="pb-0 title">
                  <div>{{ lang.secret_word }}</div>
                </v-card-title>
                <v-card-text class="pt-0">
                  <v-text-field
                    class="pt-2"
                    background-color="amber lighten-4"
                    v-model="secretWord"
                    box
                    single-line
                    type="password"
                    v-validate="changeSecretWord ? 'required' : ''"
                    data-vv-name="contentsSecretWord"
                    :error-messages="errors.collect('contentsSecretWord')"
                    required
                  >
                    {{ secretWord }}
                  </v-text-field>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex v-else-if="initialPublicationType === 'secret_word'" xs12>
              <v-btn
                class="ml-0"
                large
                round
                @click="changeSecretWord = true"
                :class="[
                  $style.btnTextStyle,
                  { 'grey lighten-1': changeSecretWord }
                ]"
              >
                <v-icon>fas fa-lock fa-fw</v-icon>
                <span class="pl-2">{{ lang.update_secret_word }}</span>
              </v-btn>
              <v-card v-show="changeSecretWord" max-width="500">
                <v-card-title class="pb-0 title">
                  <div>{{ lang.new_secret_word }}</div>
                  <v-spacer></v-spacer>
                  <div class="text-xs-right-">
                    <v-btn icon @click="changeSecretWord = !changeSecretWord">
                      <v-icon small>fas fa-times</v-icon>
                    </v-btn>
                  </div>
                </v-card-title>
                <v-card-text class="pt-0">
                  <v-text-field
                    class="pt-2"
                    background-color="amber lighten-4"
                    v-model="secretWord"
                    box
                    single-line
                    type="password"
                    v-validate="changeSecretWord ? 'required' : ''"
                    data-vv-name="contentsSecretWord"
                    :error-messages="errors.collect('contentsSecretWord')"
                    required
                  >
                    {{ secretWord }}
                  </v-text-field>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-fade-transition>
      </v-flex>

      <v-flex xs12>
        <div class="text-xs-right">
          <v-btn
            color="info"
            @click="onSaveChanges"
            :class="$style.btnTextStyle"
            :loading="isLoading"
            :disabled="
              errors.has('contentsDescription') ||
                errors.has('contentsSecretWord')
            "
          >
            {{ lang.save }}
          </v-btn>
        </div>
      </v-flex>
    </v-layout>
  </v-form>
</template>

<script>
export default {
  name: "vc-share-my-walls-settings",
  props: {
    locale: {
      type: String,
      default: ""
    },
    lang: {
      Type: Object,
      default: () => {
        return {
          MyWallsSettings: {
            retake: "撮り直す",
            description_hint: "Twitterなどに投稿した際に使用される説明文です。"
          }
        };
      }
    },
    validationLang: {
      type: Object,
      default: () => {
        return {
          required: "",
          max: {
            string: ""
          }
        };
      }
    },
    existsBookshelfThumbnailImage: { type: Boolean, default: false },
    initialBookshelfThumbnailImageUrl: { type: String, default: "" },
    titleMaxLength: { type: Number, default: 0 },
    descriptionMaxLength: { type: Number, default: 0 },
    secretWordMaxLength: { type: Number, default: 0 },
    identificationCode: { type: String, default: "" },
    initialTitle: { type: String, default: "" },
    initialDescription: { type: String, default: "" },
    initialPublicationType: { type: String, default: "" },
    readerLaunchUrl: { type: String, default: "" },
    backUrl: {
      type: String,
      default: ""
    },

    /* stateToProps */
    isBusy: { Type: Boolean, default: false },

    /* actionsToProps */
    uploadDraftWallThumbnailImage: {
      type: Function,
      default: async () => {}
    },
    saveSettingsChanges: {
      type: Function,
      default: async () => {}
    },

    /* mutationToProps */
    setIsBusy: {
      type: Function,
      default: async () => {}
    }
  },
  data: function() {
    return {
      enabledRetakeThumbnailImage: this.existsBookshelfThumbnailImage,
      draftWallThumbnailImageId: null,
      draftWallThumbnailImageUrl: this.initialBookshelfThumbnailImageUrl,
      title: this.initialTitle,
      description: this.initialDescription,
      publicationType: this.initialPublicationType,
      secretWord: "",
      errorMessage: "",
      isLoading: false,
      changeSecretWord: false,
      dictionary: {
        custom: {
          contentsTitle: {},
          contentsDescription: {},
          contentsSecretWord: {}
        }
      }
    };
  },
  mounted: function() {
    this.dictionary.custom.contentsTitle.max = this.validationLang.max.string
      .replace(":attribute", this.lang.title)
      .replace(":max", this.titleMaxLength);
    this.dictionary.custom.contentsTitle.required = this.validationLang.required.replace(
      ":attribute",
      this.lang.title
    );
    this.dictionary.custom.contentsDescription.max = this.validationLang.max.string
      .replace(":attribute", this.lang.description)
      .replace(":max", this.descriptionMaxLength);
    this.dictionary.custom.contentsDescription.required = this.validationLang.required.replace(
      ":attribute",
      this.lang.description
    );
    this.dictionary.custom.contentsSecretWord.required = this.validationLang.required.replace(
      ":attribute",
      this.lang.secret_word
    );
    this.$validator.localize(this.locale, this.dictionary);

    this.setIsBusy(true);
    window.addEventListener("message", this.onMessage3DViewerReady);
    window.addEventListener("message", this.onMessageCreateThumbnailImage);
  },
  methods: {
    onMessage3DViewerReady(e) {
      if (e.data === "3d_viewer_ready") {
        this.$refs.reader.contentWindow.postMessage(
          "createThumbnailImage",
          this.readerLaunchUrl
        );

        window.removeEventListener("message", this.onMessage3DViewerReady);
      }
    },
    async onMessageCreateThumbnailImage(e) {
      if (e.data.event) {
        if (e.data.event === "createdThumbnailImage") {
          const res = await this.uploadDraftWallThumbnailImage({
            image: e.data.image
          });

          if (res.status === 0) {
            this.draftWallThumbnailImageId = res.draftWallThumbnailImageId;
            this.draftWallThumbnailImageUrl = res.draftWallThumbnailImageUrl;
            this.enabledRetakeThumbnailImage = false;
          }

          this.setIsBusy(false);
        } else if (e.data.event === "createThumbnailImageFailed") {
          this.setIsBusy(false);
        }
      }
    },
    onRetakeThumbnail() {
      this.setIsBusy(true);
      this.$refs.reader.contentWindow.postMessage(
        "createThumbnailImage",
        this.readerLaunchUrl
      );
    },
    async onSaveChanges() {
      const result = await this.$validator.validateAll();
      if (!result) {
        return;
      }

      this.isLoading = true;

      let requestData = {
        identificationCode: this.identificationCode,
        draftWallThumbnailImageId: this.draftWallThumbnailImageId,
        title: this.title,
        description: this.description,
        publicationType: this.publicationType
      };

      if (this.changeSecretWord) {
        requestData.secretWord = this.secretWord;
      }

      const value = await this.saveSettingsChanges(requestData);

      if (value === 0) {
        location.href = this.backUrl;
      } else {
        this.isLoading = false;
      }
    }
  }
};
</script>

<style module>
.btnTextStyle {
  text-transform: none !important;
}
.headingText {
  font-weight: bold;
  font-size: 16px;
}
</style>
